import { createSlice } from '@reduxjs/toolkit';
import { Reward, Nullable } from '../../types';
import { takeOne } from '../../helpers/store';
import { Paginated, PaginationService } from '../../services/api-handlers/pagination';
import { createReward, deleteReward, getReward, listRewards, updateReward } from '../thunks/reward-thunks';
import { ReducerState } from '../configure-store';

export interface RewardState extends ReducerState {
    data: Paginated<Reward>;
    current: Nullable<Reward>;
}

const initialState: RewardState = {
    error: '',
    loading: 'none',
    requestIds: [],
    current: null,
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
};

const slice = createSlice({
    name: 'reward',
    initialState,
    reducers: {
        resetRewardCurrent: (state: RewardState) => {
            state.current = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(listRewards.pending, takeOne.pendingActionCase)
            .addCase(listRewards.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.data = action.payload;
            })
            .addCase(listRewards.rejected, takeOne.rejectedActionCase)
            .addCase(getReward.pending, takeOne.pendingActionCase)
            .addCase(getReward.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.current = action.payload;
            })
            .addCase(getReward.rejected, takeOne.rejectedActionCase)
            .addCase(createReward.pending, takeOne.pendingActionCase)
            .addCase(createReward.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.data = PaginationService.reset(state.data);
            })
            .addCase(createReward.rejected, takeOne.rejectedActionCase)
            .addCase(updateReward.pending, takeOne.pendingActionCase)
            .addCase(updateReward.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.data = PaginationService.reset(state.data);
            })
            .addCase(updateReward.rejected, takeOne.rejectedActionCase)
            .addCase(deleteReward.pending, takeOne.pendingActionCase)
            .addCase(deleteReward.fulfilled, (state, action) => {
                takeOne.fulfilledActionCase(state, action);
                state.data = PaginationService.reset(state.data);
            })
            .addCase(deleteReward.rejected, takeOne.rejectedActionCase);
    },
});

export const { resetRewardCurrent } = slice.actions;

export default slice.reducer;
